import { API, APICall } from '../Api'

export default {
  name: 'Cities',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.City.Get.Type,
        Endpoint: APICall.City.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.City.Save.Type,
        Endpoint: APICall.City.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.City.List.Type,
        Endpoint: APICall.City.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async allCounties (data) {
      const Request = {
        Type    : APICall.County.List.Type,
        Endpoint: APICall.County.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
